const serviceName = '/service/fs-chat/api'
export default serviceName
